import React from 'react';
import { CONTACT_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, WHATSAPP_DISPLAY, WHATSAPP_URL } from '../data/config';
export function Footer() {
  return <footer className="w-full border-t border-white/8 bg-ink-950 px-5 py-12 sm:px-8" data-id="element-155" data-mp="3ghc3g4fxp7pa">
      <div className="mx-auto grid w-full max-w-4xl gap-6 text-center sm:text-left md:grid-cols-2" data-id="element-156" data-mp="32pfci3q053uh">
        <div data-id="element-157" data-mp="36ppkflxcu4bz">
          <p className="text-sm font-bold text-white" data-id="element-158" data-mp="36nd6rkymqg4q">Diccionario Apple™</p>
          <p className="mt-2 text-xs leading-relaxed text-white/45" data-id="element-159" data-mp="3ufju5umdncs0">
            La guía completa para usar tu iPhone como un profesional. Porque aprovechar tu celular no debería costarte
            horas de tutoriales sueltos.
          </p>
          <p className="mt-3 text-xs leading-relaxed text-white/45" data-id="element-160" data-mp="3qdf7jfucjgev">
            Un producto de <span className="font-semibold text-white/70" data-id="element-161" data-mp="3qf9sgu5mb8iy">Celulares Nuevos Saavedra</span>, una de las
            marcas de venta de productos Apple más grandes de Argentina.
          </p>
        </div>
        <div className="text-xs leading-relaxed text-white/45 md:text-right" data-id="element-162" data-mp="2evxat0b6nh1u">
          <p data-id="element-163" data-mp="3l9si93m2mqny">Marcio Gómez · Especialista en el ecosistema Apple</p>
          <p className="mt-2" data-id="element-164" data-mp="3gbiliokp7i08">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="font-semibold text-white/60 transition-colors hover:text-white" data-id="element-165" data-mp="3gca674crbvbq">
              {INSTAGRAM_HANDLE}
            </a>{' '}
            · +180.000 seguidores
          </p>
          <p className="mt-2" data-id="element-166" data-mp="33xe1y3atysi">
            Asesor por WhatsApp:{' '}
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="font-semibold text-white/60 transition-colors hover:text-white" data-id="element-167" data-mp="33nm44yp1hk6">
              {WHATSAPP_DISPLAY}
            </a>
          </p>
          <p className="mt-2" data-id="element-168" data-mp="qub4xla5drli">{CONTACT_EMAIL}</p>
          <p className="mt-2" data-id="element-169" data-mp="mrwm316haru8">Producto educativo independiente, no afiliado ni respaldado por Apple Inc.</p>
        </div>
      </div>
      <p className="mx-auto mt-8 w-full max-w-4xl border-t border-white/8 pt-6 text-center text-[11px] uppercase tracking-[0.18em] text-white/35" data-id="element-170" data-mp="tw5y45mchom7">
        © Diccionario Apple™ {new Date().getFullYear()} — Todos los derechos reservados.
      </p>
    </footer>;
}